$(document).on('turbolinks:load', function () {
    const ajaxTarget = $(".ajax-target");
    const trajectorySelect = $('.example-trajectory-select')
    const reintegrationThresholdField = $('#trajectory_reintegration_percentage_threshold')
    const deadlineMonthsField = $('#trajectory_deadline_months_after_reintegration')
    const deadlineReminderMonthsField = $('#trajectory_deadline_reminder_months')
    const selectAllOutcomesBtn = $('#select_all_outcomes_btn')

    if(reintegrationThresholdField.val() === ''){
        deadlineMonthsField.prop('disabled', true)
        deadlineMonthsField.addClass('disabled-input')
        deadlineMonthsField.removeClass('is-valid')
        deadlineReminderMonthsField.prop('disabled', true)
        deadlineReminderMonthsField.addClass('disabled-input')
        deadlineReminderMonthsField.removeClass('is-valid')
    }

    trajectorySelect.on('change', function () {
        $.ajax({
            url: '/trajectories/new',
            data: `example_trajectory=${$(this).val()}`,
            type: 'get',
            success: (data) => {
                ajaxTarget.html(data.partial_html)
                modifyOutcomeCheckBoxes(data.outcome_indicators)
            }
        })
    })

    const modifyOutcomeCheckBoxes = (outcome_ids) => {
        $('input[name="trajectory[outcome_indicator_ids][]"]').each(function () {
            let checked = outcome_ids.includes($(this).val())
            $(this).prop('checked', checked)
        })
    }

    reintegrationThresholdField.on('input', function() {
        if($(this).val() === ''){
            deadlineMonthsField.prop('disabled', true)
            deadlineMonthsField.addClass('disabled-input')
            deadlineMonthsField.removeClass('is-valid')
            deadlineReminderMonthsField.prop('disabled', true)
            deadlineReminderMonthsField.addClass('disabled-input')
            deadlineReminderMonthsField.removeClass('is-valid')
        }else{
            deadlineMonthsField.prop('disabled', false)
            deadlineMonthsField.removeClass('disabled-input')
            deadlineReminderMonthsField.prop('disabled', false)
            deadlineReminderMonthsField.removeClass('disabled-input')
        }
    })

    selectAllOutcomesBtn.on('click', function(e) {
        e.preventDefault()
        let check = $(this).hasClass('check-all')
        $('input[name="trajectory[outcome_indicator_ids][]"]').each(function () {
            $(this).prop('checked', check)
        })
        $(this).toggleClass('check-all')
    })

})